import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';

export default function BenefitedDepartmentsMobile() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" py={4}>
        <Container>
          <Box className={classes.mainContentBox} py={4}>
            <Typography className={classes.title} component="h2">
              <b>
                Departments that can benefit from <br /> Mind the Graph
              </b>
            </Typography>

            <Box py={1}>
              <Typography variant="body2" component="p" align="center">
                A range of 80+ fields of study covered <br /> in our gallery. Check them out.
              </Typography>
            </Box>

            <Box display="flex" justifyContent="center" alignItems="center">
              <ul className={classes.list}>
                <li>* Cardiology</li>
                <li>* Neurology</li>
                <li>* Urology</li>
                <li>* Gynecology</li>
                <li>* Obstetrics</li>
                <li>* Pneumology</li>
                <li>* Pharmacy</li>
                <li>* Veterinary</li>
                <li>* Zoology</li>
                <li>* Biology</li>
                <li>* Botany</li>
                <li>* Entomology</li>
                <li>* Physics & Astronomy</li>
                <li>* History</li>
                <li>* Engineering</li>
              </ul>

              <ul className={classes.list}>
                <li>* Endocrinology</li>
                <li>* Orthopedics</li>
                <li>* Pediatrics</li>
                <li>* Hematology</li>
                <li>* Parasitology</li>
                <li>* Odontology</li>
                <li>* Ornithology</li>
                <li>* Oceanography</li>
                <li>* Chemistry</li>
                <li>* Genetics</li>
                <li>* Nanotechnology</li>
                <li>* Geography</li>
                <li>* Nutrition</li>
                <li>* Molecular science</li>
                <li>* Among others</li>
              </ul>
            </Box>

            <Box textAlign="center" pt={4}>
              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>Request a Demonstration</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
